import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = { class: "panel-label flex justify-content-between align-items-center mt-s2" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "p-dialog-footer flex-column" }

import { computed, toRef, watch } from 'vue';
import BigNumber from 'bignumber.js';
import { useI18n } from 'vue-i18n';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import { toWei } from '@/sdk/utils';
import { max } from '@/utils/bigNumber';
import { format, printUSD } from '@/utils/format';
import { Token } from '@/sdk/entities/token';
import Spinner from '@/components/Spinner.vue';
import InfoMessage from '@/components/InfoMessage.vue';
import { useMilkomedaWSCBalanceADAIntoCardanoValidator } from '@/composables/milkomeda-wrapped-smartcontract/useMilkomedaWSCBalanceADAIntoCardanoValidator';
import TokenIcon from '@/components/token/TokenIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollectModal',
  props: {
    amount: null,
    token: null,
    amountUsd: null,
    harvest: null,
    compound: null,
    cancel: null,
    inProgressCompound: { type: Boolean },
    inProgressHarvest: { type: Boolean },
    isSyrupPool: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  amount: BigNumber.Value;
  token: Token;
  amountUsd: BigNumber.Value;
  harvest: () => void;
  compound: () => void;
  cancel: () => void;
  inProgressCompound?: boolean;
  inProgressHarvest?: boolean;
  isSyrupPool?: boolean;
}



const { t } = useI18n();
const {
  milkomedaWSCBalanceADAIntoCardanoValidatorState: harvestValidatorState,
  checkBalanceADAForBridgeFromMilkomeda: checkHarvestBalanceADAForBridgeFromMilkomeda,
} = useMilkomedaWSCBalanceADAIntoCardanoValidator();
const {
  milkomedaWSCBalanceADAIntoCardanoValidatorState: compoundValidatorState,
  checkBalanceADAForBridgeOnlyADAFromCardano: checkCompoundBalanceADAForBridgeFromCardano,
} = useMilkomedaWSCBalanceADAIntoCardanoValidator();

const minADABalanceWhenHarvestRef = toRef(harvestValidatorState, 'minADABalance');
const minADABalanceWhenCompoundRef = toRef(compoundValidatorState, 'minADABalance');

const isNotEnoughADAForHarvest = computed(
  () => ENABLE_FAKE_CARDANO_NETWORK && !harvestValidatorState.isValidCardanoBalance,
);
const isNotEnoughADAForCompound = computed(
  () => ENABLE_FAKE_CARDANO_NETWORK && !compoundValidatorState.isValidCardanoBalance,
);
const isShowNotEnoughCurrencyForFee = computed(
  () => isNotEnoughADAForHarvest.value || isNotEnoughADAForCompound.value,
);
const inProgress = computed(() => props.inProgressCompound || props.inProgressHarvest);
const minADABalance = computed(() => {
  return max(
    minADABalanceWhenHarvestRef.value ?? '0',
    minADABalanceWhenCompoundRef.value ?? '0',
  ).toString();
});

watch(
  [() => props.amount.toString(), () => props.token],
  ([youEarned, token]) => {
    if (!token || !ENABLE_FAKE_CARDANO_NETWORK) return;
    const youEarnedInWei = toWei(youEarned, token.decimals);
    checkHarvestBalanceADAForBridgeFromMilkomeda(youEarnedInWei.toString(), token);
  },
  {
    immediate: true,
  },
);

watch(
  () => props.amount.toString(),
  () => {
    if (!ENABLE_FAKE_CARDANO_NETWORK) return;
    checkCompoundBalanceADAForBridgeFromCardano();
  },
  {
    immediate: true,
  },
);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('yieldPool.collectConfirmDialog.yourEarnings')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TokenIcon, {
        "icon-src": __props.token.tokenIconUrl,
        symbol: __props.token.symbol,
        size: "20",
        full: ""
      }, null, 8, ["icon-src", "symbol"]),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(_unref(format)(_unref(BigNumber)(__props.amount))), 1),
        _createElementVNode("span", _hoisted_3, " / " + _toDisplayString(_unref(printUSD)(_unref(BigNumber)(__props.amountUsd))), 1)
      ])
    ]),
    (_unref(isShowNotEnoughCurrencyForFee))
      ? (_openBlock(), _createBlock(InfoMessage, {
          key: 0,
          type: "error",
          "as-panel": "",
          class: "mt-s3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('wrappedContract.notEnoughCurrencyForFee', {
        amount: _unref(minADABalance),
        symbol: 'ADA',
      })), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        class: "button-primary w-full",
        label: _unref(t)('yieldPool.collectConfirmDialog.harvestBtn'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.harvest())),
        disabled: _unref(inProgress) || _unref(isNotEnoughADAForHarvest)
      }, {
        default: _withCtx(() => [
          (__props.inProgressHarvest)
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                color: "white",
                size: "24",
                class: "mr-s2"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(t)('yieldPool.collectConfirmDialog.harvestBtn')), 1)
        ]),
        _: 1
      }, 8, ["label", "disabled"]),
      _createVNode(_component_Button, {
        class: "button-primary w-full mt-s3",
        label: _unref(t)('yieldPool.collectConfirmDialog.compoundBtn'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.compound())),
        disabled: _unref(inProgress) || _unref(isNotEnoughADAForCompound)
      }, {
        default: _withCtx(() => [
          (__props.inProgressCompound)
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                color: "white",
                size: "24",
                class: "mr-s2"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(t)('yieldPool.collectConfirmDialog.compoundBtn')), 1)
        ]),
        _: 1
      }, 8, ["label", "disabled"]),
      _createVNode(_component_Button, {
        class: "button-base w-full mt-s3",
        label: _ctx.$t('cancel'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.cancel()))
      }, null, 8, ["label"])
    ])
  ], 64))
}
}

})